import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setModal, selectModal } from '../../../redux/modalSlice';

export default function MakeUpPaymentModal() {
  const dispatch = useDispatch();
  const modal = useSelector(selectModal);
  const [makeUpAmount, setMakeUpAmount] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const outstandingAmount = modal.options?.outstandingAmount
  const nextPaymentDate = modal.options?.nextPaymentDate

  const handleCancel = () => {
    dispatch(setModal({ is_active: false }));
  };

  const handleSchedulePayment = () => {
    // Perform the scheduling logic
    dispatch(setModal({ is_active: false }));
  };

  return modal.is_active && modal.type === 'make_up_payment' ? (
    <div className="modal is-active">
      <div className="modal-background"></div>
      <div className="modal-card column is-3">
        <header className="modal-card-head py-3">
          <p className="modal-card-title is-capitalized">
            Make-up Payment
          </p>
          <button className="delete" aria-label="close" onClick={handleCancel}></button>
        </header>
        <section
          className="modal-card-body modal-card-body pt-1 pb-1"
          style={{ height: "180px", overflow: 'hidden' }}
        >
          <div className="columns mb-0 is-flex-direction-column">
            <div className="column has-text-centered">
              <h3>Enter the amount the customer would like to make-up.</h3>
              <p>Amount Outstanding: ${outstandingAmount}</p>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Amount:</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    type="number"
                    className="input"
                    value={makeUpAmount}
                    onChange={(e) => setMakeUpAmount(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="field is-horizontal">
            <div className="field-label has-text-left">
              <label className="label has-text-weight-normal">Schedule Date:</label>
            </div>
            <div className="field-body is-flex-grow-1">
              <div className="field">
                <div className="control">
                  <input
                    type="date"
                    className="input"
                    value={selectedDate}
                    onChange={(e) => setSelectedDate(e.target.value)}
                    max={nextPaymentDate}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <footer className="modal-card-foot is-justify-content-end py-1">
          <div className="lox-form__buttons-wrapper has-text-right">
            <button type="button" className="button is-small has-background-grey has-text-white" onClick={handleSchedulePayment}>Cancel</button>
            <button type="submit" className="button is-link is-small" onClick={handleCancel}>Schedule Make-Up </button>
          </div>
        </footer>
      </div>
    </div>
  ) : null;
}
